<template>
  <div class="container">
    <My-Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="mainBox">
      <!-- 控制区域 -->
      <div class="control_box">
        <Search-bar :inputs="inputs" :selects="selects" :timeRange="timeRange" :showTypeSelect="true" @search="search"
          @reset="search" />
        <div class="control_box_bottom">
          <a-button type="primary" icon="printer" @click="downloadExcel" :disabled="tableData.length == 0">导出</a-button>
        </div>
      </div>
      <!-- 内容区域 -->
      <div class="show_box">
        <a-table :columns="columns" :data-source="tableData" :loading="loading"
          rowKey="id" :pagination="pagination" @change="handleTableChange" >
          <span slot="nameRender" slot-scope="record">
            {{ record.sub_user.name }}
            <span v-if="record.sub_user.is_deleted==1" class="outer">离职</span>
          </span>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { billDatagrid, billExcelExport, officeDatalist, postDatalist } from "@/request/api";
//引入工具函数
import util from "@/utils/util";
//引入封装的组件
import SearchBar from "@/components/common/SearchBar.vue";
import MyBreadcrumb from "@/components/common/MyBreadcrumb.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { SearchBar, MyBreadcrumb },
  data () {
    return {
      breadcrumbs: [
        {
          key: 0,
          title: "账户管理",
        },
        {
          key: 1,
          title: "账户明细",
        },
      ],
      inputs: [
        {
          placeholder: "姓名",
          model: "realname",
          width: 100,
        },
        {
          placeholder: "手机号码",
          model: "mobile",
          width: 100,
        },
      ],
      selects: [
        {
          model: "office_id",
          placeholder: "部门",
          width: 200,
          options: [
            {
              key: "",
              value: "部门",
            },
          ],
        },
        {
          model: "post_id",
          placeholder: "职务",
          width: 100,
          options: [
            {
              key: "",
              value: "职务",
            },
          ],
        },
      ],
      timeRange: {
        show: true,
        placeholderStart: "开始时间",
        placeholderEnd: "结束时间",
        rangeLimit: true
      },
      queryParam: {
        page: 1,
        office_id: "",
        post_id: "",
        realname: "",
        mobile: "",
        begin_date: "",
        end_date: "",
        transaction_type: "",
        transaction_type_child: "",
      },
      tableData: [], //从接口请求回来并在js部分整理好的表格数据
      officesData: [],
      postsData: [],
      typeData: [],
      dataForExport: [],
      loading: false,
      columns: [
        {
          title: "姓名",
          key: "sub_user.name",
          width: 120,
          scopedSlots: { customRender: "nameRender" },
        },
        {
          title: "手机",
          key: "sub_user.mobile",
          dataIndex: "sub_user.mobile",
          width: 130
        },
        {
          title: "发生额",
          key: "money",
          dataIndex: "money",
          width: 80
        },
        {
          title: "余额",
          key: "acco_amount",
          dataIndex: "acco_amount",
          width: 80
        },
        {
          title: "创建时间",
          key: "created_at",
          dataIndex: "created_at",
          width: 180
        },
        {
          title: "类型",
          key: "type_text",
          dataIndex: "type_text",
          width: 130
        },
        /*
        {
          title: "用餐时段",
          key: "meal_name",
          dataIndex: "meal_name",
          width: 100
        },
        {
          title: "消费类型",
          key: "type_name",
          dataIndex: "type_name",
          width: 100
        },*/
        {
          title: "操作人",
          key: "operation",
          dataIndex: "operation",
          width:200
        },
        {
          title: "备注",
          key: "remark",
          dataIndex: "remark",
          ellipsis: true,
        },
        // {
        //   title: "操作",
        //   key: "action",
        //   scopedSlots: { customRender: "action" },
        // },
      ], // 表格的列配置
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    initBaseData(){
      postDatalist().then(res=>{
        let items = res.data.result
        for (let i = 0; i < items.length; i++) {
          this.selects[1].options.push({
            key: items[i].id,
            value: items[i].title,
          });
        }
      })
      officeDatalist().then(res=>{
        let items = res.data.result
        for (let i = 0; i < items.length; i++) {
          this.selects[0].options.push({
            key: items[i].id,
            value: items[i].title,
          });
        }
      })
    },
    //列表下载
    downloadExcel () {
      this.$confirm({
        title: "确定导出表格?",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          this.export2Excel();
        },
        onCancel: () => { },
      });
    },
    //数据写入excel
    export2Excel () {
      billExcelExport(this.queryParam).then((res) => {
        util.acceptFileStream(res.data, "会员账户明细.xls");
      });
      /*
      var that = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/export2Excel"); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
        const tHeader = [
          "姓名",
          "手机",
          "科室/部门",
          "职务",
          "发生额",
          "余额",
          "类型",
          "用餐时段",
          "消费类型",
          "备注",
          "创建日期",
          "订单号",
          "就餐日期"
        ]; // 导出的表头名信息
        const filterVal = [
          "user_realname",
          "user_mobile",
          "user_office",
          "user_post",
          "money",
          "acco_amount",
          "type_title",
          "meal_name",
          "type_name",
          "remark",
          "created_at",
          "order_number",
          "repast_date"
        ]; // 导出的表头字段名，需要导出表格字段名
        const list = that.dataForExport;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "会员账户列表"); // 导出的表格名称，根据需要自己命名
      });*/
    },
    //格式转换
    formatJson (filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 刷新
    search (val) {
      // console.log(val);
      this.queryParam = {
        page: 1,
        office_id: val.select.office_id ? val.select.office_id : "",
        post_id: val.select.post_id ? val.select.post_id : "",
        realname: val.input.realname ? val.input.realname : "",
        mobile: val.input.mobile ? val.input.mobile : "",
        begin_date: val.timeRange.startTime,
        end_date: val.timeRange.endTime,
        transaction_type: val.selectWithSecond.transaction_type
          ? val.selectWithSecond.transaction_type
          : "",
        transaction_type_child: val.selectWithSecond.transaction_type_child
          ? val.selectWithSecond.transaction_type_child
          : "",
      };
      // console.log(this.queryParam);
      this.pagination.current = 1;
      this.getTableData();
    },
    //获取表格数据
    getTableData () {
      this.loading = true;
      billDatagrid(this.queryParam).then((res) => {
        const pagination = { ...this.pagination };
        pagination.total = res.data.result.total;
        this.pagination = pagination;
        let rowKey = 1,
          formatArr = res.data.result.items;
        for (let i = 0; i < formatArr.length; i++) {
          //因为接口返回的数组对象没有id所以给每个对象增加一个自增的rowKey作为渲染table的必要属性rowkey
          formatArr[i].rowKey = rowKey++;
        }
        this.tableData = res.data.result.items;
      }).finally(()=>{
        this.loading = false
      });
    },

    //分页
    handleTableChange (pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.queryParam.page = pagination.current;
      this.getTableData();
    },
    
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getTableData();
    this.initBaseData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { },
  beforeCreate () { }, //生命周期 - 创建之前
  beforeMount () { }, //生命周期 - 挂载之前
  beforeUpdate () { }, //生命周期 - 更新之前
  updated () { }, //生命周期 - 更新之后
  beforeDestroy () { }, //生命周期 - 销毁之前
  destroyed () { }, //生命周期 - 销毁完成
  activated () { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.mainBox {
  .control_box {
    background-color: white;
    padding: 20px;
    .control_box_bottom {
      margin-top: 20px;
    }
  }
  .show_box {
    width: 100%;
    padding-top: 10px;
  }
}
</style>